import * as React from 'react';
import { IColorProps } from './types';
import {
  ColorContainer,
  ColorLabel,
  ColorBackground,
  RemoveIconContainer,
} from './styled';
import { CloseIcon } from '@unfold/icon';

export const Color: React.FC<IColorProps> = ({ color, onRemove }) => {
  return (
    <ColorContainer elevation="card" css={{ height: 185 }}>
      <ColorBackground color={color.value}>
        <RemoveIconContainer
          className="remove-icon"
          onClick={(): void => onRemove(color.uuid)}
        >
          <CloseIcon />
        </RemoveIconContainer>
      </ColorBackground>
      <ColorLabel>{color.value}</ColorLabel>
    </ColorContainer>
  );
};
